<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Effectuer un <strong>tranfert d'argent </strong> / Information générale          </div>
          <b-row class="form-group">
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <label for="montant_transfere">Montant HT (*)</label>
              <b-form-input id="montant_transfere" type="number" min="5" @blur.native="postmontant()" v-model="mandats.montant_transfere" placeholder="Montant Hors Taxe" class="form-control"></b-form-input>
              <!--<b-form-group>
                <b-input-group>
                  <b-form-input type="number" min="1" v-model="mandats.montant_transfere" placeholder="Montant Hors Taxe"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="postmontant()"><i class="fa fa-money"></i> TTC</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>-->
            </b-col>
            <b-col md="6">
              <label for="montant_ttc">Montant TTC</label>
              <b-form-input id="montant_ttc" type="number" v-model="mandats.montant_ttc" placeholder="Montant toute taxe comprise" disabled></b-form-input>
            </b-col>
            
          </b-row>
        </b-card> 
        <b-card v-if="displayCentreData">
          <div slot="header">
            Information du centre d'appel <strong></strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
                <label for="entite_id">Entite *</label>
                <el-select style="display:block;"
                  id="entite_id"
                  v-model="entite_id"
                  @change="verif_entity()"
                  loading-text="Chargement en cours"
                  no-match-text="Entité non trouvée"
                  no-data-text="Aucune données trouvées"
                  size="small"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Rechercher le nom de votre entité"
                  :remote-method="remoteEntities"
                  :loading="loading">
                  <el-option
                    v-for="item in options4"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
            </b-col>
            <b-col md="6" v-if="exists_entity">
              <label for="agence_id">Agence *</label>
                <el-select style="display:block;"
                  id="agence_id"
                  v-model="agence_id"
                  @change="verif_agency()"
                  loading-text="Chargement en cours"
                  no-match-text="Agence non trouvée"
                  no-data-text="Aucune données trouvées"
                  size="small"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Rechercher le nom de votre agence"
                  :remote-method="remoteAgencies"
                  :loading="loading">
                  <el-option
                    v-for="item in options6"
                    :key="item.value"
                    :label="item.text"
                    :value="item.text">
                  </el-option>
                </el-select>
            </b-col>
            <b-col md="6" v-if="exists_agency">
              <label for="user_id">Utilisateur *</label>
                <el-select style="display:block;"
                  id="user_id"
                  v-model="user_id"
                  loading-text="Chargement en cours"
                  no-match-text="Utilisateur non trouvé"
                  no-data-text="Aucune données trouvées"
                  size="small"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Rechercher le nom de l'utilisateur"
                  :remote-method="remoteUsers"
                  :loading="loading">
                  <el-option
                    v-for="item in options5"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
            </b-col>
          </b-row>
        </b-card>    
        <b-card>
          <div slot="header">
            Information sur l'emetteur <strong></strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
              <label for="nom_emetteur">Nom Emetteur (*)</label>
              <b-form-input id="nom_emetteur" type="text" v-model="mandats.nom_emetteur" placeholder="Nom de l'emetteur"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="prenom_emetteur">Prenom(s) Emetteur (*)</label>
              <b-form-input id="prenom_emetteur" type="text" v-model="mandats.prenom_emetteur" placeholder="Prénom(s) de l'emetteur"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <label for="telephone_emetteur">Téléphone Emetteur (*)</label>
              <b-form-input id="telephone_emetteur" type="text" v-model="mandats.telephone_emetteur" placeholder="Téléphone de l'émetteur"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="adresse_emetteur">Adresse Emetteur</label>
              <b-form-input id="adresse_emetteur" type="text" v-model="mandats.adresse_emetteur" placeholder="Adresse, email de l'emetteur"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <label for="piece_libelle">Type de pièce (*)</label>
              <b-form-select id="piece_libelle" v-model="mandats.piece_libelle" :plain="true" :options="options_typepiece">
              </b-form-select>
            </b-col>
            <b-col md="6">
              <label for="num_piece_emetteur">N° Pièces (*)</label>
              <b-form-input id="num_piece_emetteur" type="text" v-model="mandats.num_piece_emetteur" placeholder="Numéro de la pièce"></b-form-input>
            </b-col>
          </b-row>
          <!--<b-row class="form-group">  
            <b-col md="6">
              <label for="solde">Nombre de Bénéficiaires</label>
              <b-form-input type="number" min="1" v-model="mandats.num_piece" placeholder="Nombre de bénéficiaires"></b-form-input>
            </b-col>
          </b-row>-->
        </b-card>
        <b-card>
          <div slot="header">
            Information sur le bénéficiaire <strong></strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
              <label for="nom_benef">Nom Bénéficiaire (*)</label>
              <b-form-input id="nom_benef" type="text" v-model="mandats.nom_benef" placeholder="Nom du bénéficiaire"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="prenom_benef">Prenom(s) Bénéficiaire (*)</label>
              <b-form-input id="prenom_benef" type="text" v-model="mandats.prenom_benef" placeholder="Prénom(s) du bénéficiaire"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <label for="telephone_benef">Téléphone Bénéficiaire (*)</label>
              <b-form-input id="telephone_benef" type="text" v-model="mandats.telephone_benef" placeholder="Téléphone du bénéficiaire"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="adresse_benef">Adresse Bénéficiaire (*)</label>
              <b-form-input id="adresse_benef" type="text" v-model="mandats.adresse_benef" placeholder="Addresse du bénéficiaire"></b-form-input>
            </b-col>
          </b-row>
          <div slot="footer">
            <span v-if="can('operation-create')"><b-button type="submit" size="sm" variant="primary" @click.prevent="post()"><i class="fa fa-dot-circle-o"></i> Valider</b-button></span>
            <b-button type="reset" @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>    
          
    </b-col>
  </b-row>
</template>

<script>
import api from '../../../api/'
export default {
  name: 'tables',
  data(){
    return {
      displayCentreData:false,
      exists_entity:false,
      exists_agency:false,
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      display_atm :true,
      options : [],
      options_user : [],
      options_agency : [],
      options_typepiece : [],
      options_typeoperation : [],
      mandats:{
        piece_libelle: "",
        nom_emetteur: "",
        prenom_emetteur: "",
        adresse_emetteur: "",
        telephone_emetteur: "",
        num_piece_emetteur: "",
        montant_transfere: "",
        montant_ttc: "",
        nom_benef: "",
        prenom_benef: "",
        adresse_benef: "",
        telephone_benef: ""
      },
      entite_id:'',
      user_id:'',
      agence_id:'',
      atm:[],
      typepiece:[],
      entities:[],
      users:[],
      agences:[],
      typeoperation:[],
      serverParams: {
        page:1,
        current_page: 1,
        paginate: 20
      },
      options4: [],
      options: [],
      options5: [],
      options6: [],
      value9: [],
      list: [],
      loading: false,
      states: []
    }
  },
  methods:{
     goBack() {
        this.$router.go(-1)
      },
    countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    async post(){
        if(this.displayCentreData==true){
          let centre = {
              entity_id:this.entite_id,
              operateur_id:this.user_id
          }
          Object.assign(this.mandats,centre)
        }
        this.response = await this.$store.dispatch('mandate/post_mandates',this.mandats)
        this.showAlert()
        this.scrollToTop()
        if(this.response.success==true){
          if(this.displayCentreData!=true){
            let solde = await api.atm.get_auth_guichets(token)
            localStorage.setItem('solde', solde.data.data.solde)
          }
          this.reset()
          //console.log("pdf generé 1 ",this.response.data.content)
          //window.location.href=this.response;
          window.open(this.response.data.content, "_blank")
          setTimeout(function(){ location.reload(); }, 3000);
        }
    },
    async get_all_typepieces(){
          //this.typepiece = store.getters['typepiece/rows'];
          await this.$store.dispatch('typepiece/get_all_typepieces',this.serverParams).then(()=>{
            return this.typepiece =  store.getters['typepiece/rows'];
          })
          this.typepiece.forEach((element)=>{
              this.options_typepiece.push({
                value:element.libelle,
                text:element.libelle
              })
          })
    },
    async updateSolde(){
      if(this.displayCentreData==true){
        let solde = await api.atm.get_auth_guichets(token)
        localStorage.setItem('solde', solde.data.data.solde)
      }
    },
    // async get_all_typeoperations(){
    //       //this.typeoperation = store.getters['typeoperation/rows'];
    //       await this.$store.dispatch('typeoperation/get_all_typeoperations').then(()=>{
    //         return this.typeoperation =  store.getters['typeoperation/rows'];
    //       })
    //       this.typeoperation.forEach((element)=>{
    //           this.options_typeoperation.push({
    //             value:element.id,
    //             text:element.libelle
    //           })
    //       })
    //       let envoi = this.typeoperation.find(function(element){
    //           return element.code_operation == 'TAE' 
    //       })
          
    //       let retrait = this.typeoperation.find(function(element){
    //           return element.code_operation == 'TAR' 
    //       })
    //       this.mandats.typeoperation_id_envoi= envoi.id
    //       this.mandats.typeoperation_id_retrait=retrait.id
    // },
    
    scrollToTop() {
        window.scrollTo(0,0);
    },
    async postmontant(){
        let data = {
          montant_transfere:this.mandats.montant_transfere
        }
        this.response = await this.$store.dispatch('mandate/montantttc',data)
        this.mandats.montant_ttc = this.$store.getters['mandate/getMontant']
        this.showAlert()
        //console.log(this.$store.getters['mandate/getMontant'])
    },
    remoteEntities(query) {
        this.get_all_entities(query)
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options4 = this.t.filter(item => {
              return item.text.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
          console.log("ma requete 2 ",this.t)
        } else {
          this.options4 = [];
        }
        this.options = [] 
    },
    remoteAgencies(query) {
        this.get_all_agencies_by_entity(query)
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options6 = this.t_agency.filter(item => {
              return item.text.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
          
        } else {
          this.options6 = [];
        }
        this.options_agency = [] 
    },
    remoteUsers(query) {
        this.get_all_users_by_entity(query)
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options5 = this.t_user.filter(item => {
              return item.text.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
          //console.log("ma requete 2 ",this.t_user)
        } else {
          this.options5 = [];
        }
        this.options_user = [] 
    },
    reset(){
        this.mandats.nom_emetteur= "",
        this.mandats.prenom_emetteur= "",
        this.mandats.adresse_emetteur= "",
        this.mandats.telephone_emetteur= "",
        this.mandats.num_piece_emetteur= "",
        this.mandats.montant_transfere= "",
        this.mandats.montant_ttc= "",
        this.mandats.nom_benef= "",
        this.mandats.prenom_benef= "",
        this.mandats.adresse_benef="",
        this.mandats.telephone_benef= "",
        this.entite_id="",
        this.user_id=""
    },
    async get_auth_roles(){
        let response = await this.$store.dispatch('role/get_auth_roles',localStorage.getItem('token'))
        response.data.forEach((element)=>{
          if(element.toUpperCase()=='CENTRE APPEL'){
              this.displayCentreData=true
          }
        })
    },
    async get_all_entities(query){
        let serverParams= {
          page:1,
          current_page: 1,
          paginate: 10,
          nom_commercial: query,
        }
        await this.$store.dispatch('entity/get_all_entities',serverParams).then(()=>{
          return this.entities = store.getters['entity/rows'];    
        })
        this.entities.forEach((element)=>{
            
            this.options.push({
              value:element.id,
              text:element.nom_commercial.toUpperCase(),
            })
        })
        this.t = this.options
    },
    verif_entity(){
      console.log(this.entite_id)
      if(this.entite_id && this.entite_id != ''){
        this.exists_entity=true
        this.agence_id=''
        this.options6=[]
        this.options_agency=[]
      }else{
        this.exists_entity=false
        this.agence_id=''
        this.options6=[]
        this.options_agency=[]
      }
    },
    verif_agency(){
      
      if(this.agence_id && this.agence_id != ''){
        this.exists_agency=true
        this.user_id=''
        this.options5=[]
        this.options_user=[]
      }else{
        this.exists_agency=false
        this.user_id=''
        this.options5=[]
        this.options_user=[]
      }
    },
    async get_all_users_by_entity(query){
        let serverParams= {
          entite_id:this.entite_id,
          page:1,
          current_page: 1,
          paginate: 10,
          name: query,
        }
        console.log("ff ",this.agence_id)
        await this.$store.dispatch('user/get_all_users_by_entity',serverParams).then(()=>{
          return this.users = store.getters['user/rows'];    
        })
        let y = this.users.filter(element=>element.role_name.search("Operateur")!=-1)
        console.log(y)
        y = y.filter(element=>element.agence_nom.search(this.agence_id)!=-1)
        
        y.forEach((element)=>{
            this.options_user.push({
              value:element.id,
              text:element.name.toUpperCase(),
            })
        })
        this.t_user = this.options_user
    },
    async get_all_agencies_by_entity(query){
        let serverParams= {
          entite_id:this.entite_id,
          page:1,
          current_page: 1,
          paginate: 10,
          name: query,
        }

        await this.$store.dispatch('agency/get_all_agencies_by_entity',serverParams).then(()=>{
          return this.agences = store.getters['agency/rows'];    
        })
        //let y = this.users.filter(element=>element.role_name.search("Operateur")!=-1)
        this.agences.forEach((element)=>{
            this.options_agency.push({
              value:element.id,
              text:element.nom_agence.toUpperCase(),
            })
        })
        this.t_agency = this.options_agency
    } 
  },
  mounted(){
    this.get_all_entities('')
    this.get_all_users_by_entity('')
    this.get_all_agencies_by_entity('')
    this.updateSolde()
    this.get_all_typepieces()
    this.get_auth_roles()
    
  }
}
</script>
